import {debounce} from 'es-toolkit';

import {setMediaBreakpointAction, setMediaInnerHeightAction} from 'app/utils/mediaBreakpoint/store/mediaBreakpointActions';

const getInnerHeight = require('ios-inner-height');

export const initMediaListeners = () => {
    function updateMedia() {
        setMediaBreakpointAction(window.innerWidth);
        setMediaInnerHeightAction(getInnerHeight());
    }

    const updateMediaDebounced = debounce(updateMedia, 300);

    updateMedia();

    const handler = () => {
        updateMediaDebounced();
    };

    window.addEventListener('resize', handler);

    return () => {
        window.removeEventListener('resize', handler);
    };
};
